import { useContext, } from 'react'
// import { AuthContext, } from './AuthProvider';
import { AuthContext, AuthContextType } from './AuthContext';

export default function useAuth() {
    // const contextValue = useContext(AuthContext);
    let contextValue = AuthContextType;
    contextValue = useContext(AuthContext);
    return contextValue;
}